import { useBasketQuery } from '@/features/basket/api/query/basket';
import { FlyBasket } from '@/features/navigation/components/fly-basket/fly-basket';
import { NavElement } from '@/features/navigation/components/main-section/nav-element';
import { usePathname } from '@/navigation';
import { BASKET_ROUTES, RESERVATION_ROUTES } from '@/routes';
import {
  type FlyBasketStore,
  useFlyBasketStore,
} from '@/store/fly-basket-store';
import { Basket } from '@phosphor-icons/react/dist/ssr';
import { useTranslations } from 'next-intl';
import FocusLock from 'react-focus-lock';

const selector = ({ isOpen }: FlyBasketStore) => isOpen;

export const BasketNavElement = () => {
  const t = useTranslations('navigation.main_section');
  const pathname = usePathname();
  const enabled = !pathname.includes(RESERVATION_ROUTES.RESERVATION_UPGRADE);

  const { data } = useBasketQuery(enabled);
  const basketProductsLength =
    (data?.products?.length || 0) + (data?.accessories?.length || 0);

  const isOpen = useFlyBasketStore(selector);

  return (
    <div className="relative h-full l:h-auto">
      <NavElement
        text={t('basket')}
        icon={Basket}
        redirect={BASKET_ROUTES.MAIN}
        badgeNumber={basketProductsLength}
      />
      <FocusLock
        className="flex h-full w-full flex-col s:self-start self-end"
        group="fly-basket"
        disabled={!isOpen}
      >
        <FlyBasket />
      </FocusLock>
    </div>
  );
};
